module.exports = __webpack_public_path__ + "img/water.cce96720.png";